import React from 'react'

import { useReportPageContext } from '../contexts/report-page.context'
import { ControlBar, FILTER_SIZES } from './control-bar'

import { useStyles } from './page-control-bar.style'

export const PageControlBar = function ({ className = '', filterDefinition }) {
  const classes = useStyles()
  const reportPageContext = useReportPageContext()

  function onControlBarChange (selections, changes) {
    reportPageContext.setPageControlBarState({ selections, changes })
  }

  return <div className={`${classes.pageControlBar} ${className}`} data-qa="page-control-bar">
    <ControlBar
      filterDefinition={filterDefinition}
      standaloneFilterSize={FILTER_SIZES.MEDIUM}
      alwaysShowSelectDropdown={true}
      onChange={onControlBarChange}
    />
  </div>
}
